module.exports = __webpack_public_path__ + "media/images/fadp-cross-cd9f8d0e.png";